import React from "react";
import styled from "styled-components/macro";
import { isAndroid, isDesktop, isIos, redirectToStore } from "../../tools/device";
import { useLocation } from "react-router";
import ShopIcon from "@mui/icons-material/Shop";
import AppleIcon from "@mui/icons-material/Apple";
import LinkExt from "../../components/other/LinkExt";
import { LoginButton } from "./LoginButton";
import { REFERRER_FROM_URL } from "../../components/initializers/ReferrerCounter.model";
import { MAIN } from "../RootRouter.config";

const Wrap = styled.div`
  margin: 20px 0;
`;

const SLoginButton = styled(LoginButton)`
  margin: 5px 24px;
  width: calc(100% - 48px);
`;

export const useOpenAppOrStore = () => {
  const location = useLocation();
  return () => {
    const path = location.pathname.length > 1 ? location.pathname : MAIN.url;
    window.location.replace("com.duocards.app:/" + path);
    setTimeout(redirectToStore, 100);
  };
};

type Props = { children: React.ReactNode };

const DownloadButton: React.FC<Props> = ({ children }) => {
  const openAppOrStore = useOpenAppOrStore();
  const referrer = window[REFERRER_FROM_URL] ? "&referrer=" + window[REFERRER_FROM_URL] : "";

  if (isDesktop()) {
    return (
      <Wrap>
        {!isIos() && (
          <div>
            <LinkExt href={"https://play.google.com/store/apps/details?id=com.duocards.app" + referrer}>
              <img src="https://cdn.duocards.com/svg/googlePlay.svg" alt="Google Play" width={170} />
            </LinkExt>
          </div>
        )}
        {!isAndroid() && (
          <div>
            <LinkExt href="https://apps.apple.com/us/app/duocards-learning-decks/id1508159917">
              <img src="https://cdn.duocards.com/svg/appStore.svg" alt="App Store" width={170} />
            </LinkExt>
          </div>
        )}
      </Wrap>
    );
  }

  return (
    <SLoginButton onClick={openAppOrStore}>
      {isAndroid() && <ShopIcon style={{ fontSize: 20 }} />}
      {isIos() && <AppleIcon style={{ fontSize: 20 }} />}
      &nbsp; {children}
    </SLoginButton>
  );
};

export default DownloadButton;
